.teacherSelector {
  width: 400px;
  max-width: 100%;
}
